export const env = process.env.GATSBY_ENV || "DEVELOPMENT";

let urlPrefix;
let urlFibank;
let magicLinkRedirect;
let webSocketPrefix;
let apiURL;
let chatGPTWebSocket;
let chatGPTWebSocketV2;
let chatGPTWebSocketStreamable;
let chatGPTSpeechWebSocket;
let chatGPTVoiceToText;

if (env === "DEVELOPMENT") {
  urlPrefix = "http://localhost:1337/boleron"; // "http://10.0.2.2:1337/"; for android app
  webSocketPrefix = "ws://localhost:1337/boleron";
  urlFibank = "https://mdpay-test.fibank.bg/ecomm_v2/ClientHandler";
  magicLinkRedirect = "http://localhost:8000";
  chatGPTWebSocket = "http://localhost:1333/development/universal";
  chatGPTWebSocketV2 = "http://localhost:1333/development/universal-v2";
  chatGPTWebSocketStreamable = "http://localhost:1333/development/streamable";
  chatGPTSpeechWebSocket = "http://localhost:1333/development/universal-speech";
  chatGPTVoiceToText = "http://localhost:1333/development/voice-to-text";
} else if (env === "PRODUCTION") {
  urlPrefix = "https://api.boleron.bg:443/boleron";
  webSocketPrefix = "wss://api.boleron.bg/boleron";
  urlFibank = "https://mdpay.fibank.bg/ecomm_v2/ClientHandler";
  magicLinkRedirect = "https://www.boleron.bg";
  chatGPTWebSocket = "https://boleron-chatbot-gpt.azurewebsites.net/production/universal";
  chatGPTWebSocketV2 = "https://boleron-chatbot-gpt.azurewebsites.net/production/universal-v2";
  chatGPTWebSocketStreamable = "https://boleron-chatbot-gpt.azurewebsites.net/production/streamable";
  chatGPTSpeechWebSocket = "https://boleron-chatbot-gpt.azurewebsites.net/production/universal-speech";
  chatGPTVoiceToText = "https://boleron-chatbot-gpt.azurewebsites.net/production/voice-to-text";
} else if (env === "STAGING") {
  // staging
  urlPrefix = "https://boleron-devapi.azurewebsites.net/boleron";
  webSocketPrefix = "wss://boleron-devapi.azurewebsites.net/boleron";
  urlFibank = "https://mdpay-test.fibank.bg/ecomm_v2/ClientHandler";
  magicLinkRedirect = "https://staging.boleron.bg";
  chatGPTWebSocket = "https://boleron-staging-chatbot-gpt-b9bpeta8g4avdncm.westeurope-01.azurewebsites.net/staging/universal";
  chatGPTWebSocketV2 = "https://boleron-chatbot-gpt.azurewebsites.net/production/universal-v2"; // switched to prods api endpoint
  chatGPTWebSocketStreamable = "https://boleron-staging-chatbot-gpt-b9bpeta8g4avdncm.westeurope-01.azurewebsites.net/staging/streamable";
  chatGPTSpeechWebSocket = "https://boleron-staging-chatbot-gpt-b9bpeta8g4avdncm.westeurope-01.azurewebsites.net/staging/universal-speech";
  chatGPTVoiceToText = "https://boleron-staging-chatbot-gpt-b9bpeta8g4avdncm.westeurope-01.azurewebsites.net/staging/voice-to-text";
}

export default {
  urlPrefix,
  urlFibank,
  magicLinkRedirect,
  webSocketPrefix,
  apiURL,
  chatGPTWebSocket,
  chatGPTWebSocketV2,
  chatGPTWebSocketStreamable,
  chatGPTSpeechWebSocket,
  chatGPTVoiceToText
};
